import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Jira extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M21.081,2H10.487a4.805,4.805,0,0,0,4.782,4.783h1.952V8.666A4.8,4.8,0,0,0,22,13.446V2.919A.924.924,0,0,0,21.081,2Z" />
        <path d="M15.839,7.279H5.245a4.805,4.805,0,0,0,4.779,4.779h1.952v1.891a4.8,4.8,0,0,0,4.782,4.776V8.2a.924.924,0,0,0-.919-.919Z" />
        <path d="M10.594,12.554H0a4.805,4.805,0,0,0,4.782,4.783H6.74v1.884A4.8,4.8,0,0,0,11.513,24V13.473a.924.924,0,0,0-.919-.919Z" />
      </svg>
    );
  }
}

export default Jira;
